// extracted by mini-css-extract-plugin
export default {"root":"CollectionViewDesktop_root__S7Emw","top":"CollectionViewDesktop_top__sueQz","content":"CollectionViewDesktop_content__VtDPX","bottom":"CollectionViewDesktop_bottom__1V4pL"};